module.exports = __webpack_public_path__ + "img/yxdt-img.5209bf71.png";